var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "9", height: "17", viewBox: "0 0 9 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M.019 8.359c.056.668.36 1.317.902 1.796l6.583 5.82a.9.9 0 0 0 1.192-1.35L2.113 8.807a.9.9 0 0 1-.003-1.345l6.59-5.89A.9.9 0 0 0 7.5.229L.91 6.119a2.7 2.7 0 0 0-.872 1.618 1.694 1.694 0 0 0-.02.622z", fill: "currentColor" })
  );
});